(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    /* Inject a savings badge next to the price when the product is on sale.
     Locale-aware: works with VND (1.234.000₫), EUR (1.234,50€), USD ($1,234.50), etc.
     Output format mirrors the compare-at price string so symbol position,
     thousands separator and decimal digits all match the active currency. */
  (function () {
    /* Parse a price string in any locale. Detects whether the last separator
       is a decimal mark (1–2 trailing digits) or a thousands mark. */
    function parsePrice(str) {
      if (!str) return NaN;
      var s = str.replace(/[^\d.,]/g, '');
      if (!s) return NaN;
      var lastDot = s.lastIndexOf('.');
      var lastComma = s.lastIndexOf(',');
      var lastSep = Math.max(lastDot, lastComma);
      if (lastSep === -1) return parseFloat(s);
      var tailLen = s.length - lastSep - 1;
      var sepChar = s[lastSep];
      var sepCount = (s.match(new RegExp('\\' + sepChar, 'g')) || []).length;
      /* Treat as decimal when last separator appears once and is followed by 1–2 digits */
      var isDecimal = tailLen >= 1 && tailLen <= 2 && sepCount === 1;
      if (isDecimal) {
        var intPart = s.slice(0, lastSep).replace(/[.,]/g, '');
        var fracPart = s.slice(lastSep + 1);
        return parseFloat(intPart + '.' + fracPart);
      }
      return parseFloat(s.replace(/[.,]/g, ''));
    }

    /* Format a number using the same locale conventions as a template string.
       template: original price string from DOM (e.g. "2.167.000₫" or "$2,167.50") */
    function formatLikeTemplate(value, template) {
      var numMatch = template.match(/[\d][\d.,\s]*/);
      if (!numMatch) return String(value);
      var numStr = numMatch[0];
      var numStart = template.indexOf(numStr);
      var before = template.slice(0, numStart);
      var after = template.slice(numStart + numStr.length);

      var lastDot = numStr.lastIndexOf('.');
      var lastComma = numStr.lastIndexOf(',');
      var lastSep = Math.max(lastDot, lastComma);
      var thousandsSep = '';
      var decimalSep = '';
      var decimalDigits = 0;
      if (lastSep !== -1) {
        var tailLen = numStr.length - lastSep - 1;
        var sepChar = numStr[lastSep];
        var sepCount = (numStr.match(new RegExp('\\' + sepChar, 'g')) || []).length;
        if (tailLen >= 1 && tailLen <= 2 && sepCount === 1) {
          decimalSep = sepChar;
          decimalDigits = tailLen;
          thousandsSep = decimalSep === '.' ? ',' : '.';
        } else {
          thousandsSep = sepChar;
        }
      }

      var rounded = decimalDigits > 0 ? value.toFixed(decimalDigits) : String(Math.round(value));
      var parts = rounded.split('.');
      var intPart = parts[0];
      var fracPart = parts[1] || '';
      if (thousandsSep) {
        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      }
      var numOut = decimalDigits > 0 ? intPart + decimalSep + fracPart : intPart;
      return before + numOut + after;
    }

    function injectSavingsBadge(priceEl) {
      var saleEl = priceEl.querySelector('.price-item--sale');
      var compareEl = priceEl.querySelector('.compare-at-price');
      if (!saleEl || !compareEl) return;

      var compareStr = compareEl.textContent.trim();
      var sale = parsePrice(saleEl.textContent);
      var compare = parsePrice(compareStr);
      if (isNaN(sale) || isNaN(compare) || compare <= sale) return;

      var savings = compare - sale;
      var savingsStr = formatLikeTemplate(savings, compareStr);

      var existing = priceEl.querySelector('.pd-savings-badge');
      var badgeText = 'Save ' + savingsStr;
      if (existing) {
        if (existing.textContent !== badgeText) existing.textContent = badgeText;
        return;
      }
      var badge = document.createElement('span');
      badge.className = 'pd-savings-badge';
      badge.textContent = badgeText;

      var container = priceEl.querySelector('[ref="priceContainer"]') || priceEl;
      container.appendChild(badge);
    }

    function init() {
      document
        .querySelectorAll(
          '#ProductInformation-' +
            document.currentScript?.closest('[id^="ProductInformation"]')?.id?.split('-')[1] +
            ' product-price, .product-details product-price'
        )
        .forEach(function (el) {
          injectSavingsBadge(el);
          const observer = new MutationObserver(function () {
            injectSavingsBadge(el);
          });
          observer.observe(el, { childList: true, subtree: true });
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
